import { fetchConToken } from "../helpers/fetch";
import { handleErrorApi } from "../helpers/randoms";
import { startAlerta } from "./ui/alertas";
import { finishSpinner, startSpinner } from "./ui/spinner";


export const modificarFamiliar = (datos) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Afiliados/modificacionFamiliares`, datos, "POST");
        const body = await response.json();

        if (response.ok) {
            dispatch(startAlerta("Afiliado modificado correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner()); 
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar el afiliado.", "Ha ocurrido un error. Intente nuevamente")
    }
};